/**
 * @desc 入库单导出
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.inPlanMaster.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/inPlanMaster/export`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
